// extracted by mini-css-extract-plugin
export default {"title":"onboarding-choice_title__bbatB","card":"onboarding-choice_card__sKRFx","cutted":"onboarding-choice_cutted__Kz+QL"};